  document.addEventListener('contextmenu', function(e) {
    if (e.target.tagName === 'AUDIO') e.preventDefault();
  });

  function formatTime(s) {
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return m + ':' + String(sec).padStart(2, '0');
  }

  document.querySelectorAll('.audio-player').forEach(function(player) {
    const audio    = player.querySelector('audio');
    const btn      = player.querySelector('.audio-player__btn');
    const fill     = player.querySelector('.audio-player__fill');
    const thumb    = player.querySelector('.audio-player__thumb');
    const bar      = player.querySelector('.audio-player__bar');
    const duration = player.querySelector('.audio-player__duration');

    // Toggle play/pause
    btn.addEventListener('click', function() {
      if (audio.paused) {
        // Pause all other players first
        document.querySelectorAll('.audio-player audio').forEach(function(a) {
          if (a !== audio) {
            a.pause();
            a.closest('.audio-player').classList.remove('is-playing');
          }
        });
        audio.play();
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function() {
      player.classList.add('is-playing');
      btn.setAttribute('aria-label', 'Pauzeren');
    });

    audio.addEventListener('pause', function() {
      player.classList.remove('is-playing');
      btn.setAttribute('aria-label', 'Afspelen');
    });

    // Show total duration once metadata is loaded
    audio.addEventListener('loadedmetadata', function() {
      duration.textContent = formatTime(audio.duration);
    });

    // Update progress bar
    audio.addEventListener('timeupdate', function() {
      if (!audio.duration) return;
      const pct = (audio.currentTime / audio.duration) * 100;
      fill.style.width = pct + '%';
      thumb.style.left = pct + '%';
    });

    audio.addEventListener('ended', function() {
      fill.style.width = '0%';
      thumb.style.left = '0%';
    });

    // Scrubbing
    function seek(e) {
      const rect = bar.getBoundingClientRect();
      const x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
      audio.currentTime = (x / rect.width) * audio.duration;
    }

    let dragging = false;

    bar.addEventListener('mousedown', function(e) {
      dragging = true;
      seek(e);
    });

    document.addEventListener('mousemove', function(e) {
      if (dragging) seek(e);
    });

    document.addEventListener('mouseup', function() {
      dragging = false;
    });

    // Touch support
    bar.addEventListener('touchstart', function(e) {
      seek(e.touches[0]);
    }, { passive: true });

    bar.addEventListener('touchmove', function(e) {
      seek(e.touches[0]);
    }, { passive: true });
  });